
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/external_services/line/setting",
      function () {
        return require("private-next-pages/external_services/line/setting/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/external_services/line/setting"])
      });
    }
  